import React, { useRef, useState, useEffect } from 'react';
import SmiWidget from '../../components/smiWidgets/SmiWidget';

export const SideBar = ({isFull, isDesktop, widgetBlocks }) => {
    const [visibleWidgets, setVisibleWidgets] = useState(1);
    const divRef = useRef(null);

    useEffect(() => {
        const updateDivHeight = () => {
            if (divRef.current) {
                const height = divRef.current.offsetHeight;
                if (height < 450) {
                    setVisibleWidgets(1);
                } else if (height < 700) {
                    setVisibleWidgets(2);
                } else if (height < 1000) {
                    setVisibleWidgets(3);
                } else {
                    setVisibleWidgets(4);
                }
            }
        };
        updateDivHeight();
        window.addEventListener('resize', updateDivHeight);
        return () => {
            window.removeEventListener('resize', updateDivHeight);
        };
    }, []);

    return (
        <div className="sticky-block" ref={divRef}>
            <div className="sticky-block-content">
                <SmiWidget
                    isDesktop={isDesktop}
                    isFull={isFull}
                    blockIds={widgetBlocks}
                    visibleWidgets={visibleWidgets}
                />
            </div>
        </div>
    );
}
